import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyD6wuOSz_CVESRQtGLafHxOla5sW3IE42s",
  authDomain: "charity-and-philanthropy-swg.firebaseapp.com",
  projectId: "charity-and-philanthropy-swg",
  storageBucket: "charity-and-philanthropy-swg.firebasestorage.app",
  messagingSenderId: "1049304680965",
  appId: "1:1049304680965:web:cda9f2249a92bc53e7ea6c"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};